import { render, staticRenderFns } from "./address-card.vue?vue&type=template&id=6fb650ba&scoped=true&"
import script from "./address-card.vue?vue&type=script&lang=js&"
export * from "./address-card.vue?vue&type=script&lang=js&"
import style0 from "./address-card.vue?vue&type=style&index=0&id=6fb650ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb650ba",
  null
  
)

export default component.exports